import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import RoutesPage from './routes';

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <RoutesPage />
    </LocalizationProvider>
  );
}

export default App;
